














































import { Component, Vue, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus.js';

import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import TypeBox from '@/components/TypeBox/TypeBox.vue';
import ResumeCard from '@/componentsV2/molecules/ResumeCard/ResumeCard.vue';
import AdminTabs from '@/componentsV2/molecules/AdminTabs/AdminTabs.vue';

import CustomerRecentActivity from './CustomerRecentActivity.vue';
import CustomerStoresVisited from './CustomerStoresVisited.vue';

@Component({
  components: {
    SideModalHeader,
    TypeBox,
    ResumeCard,
    AdminTabs,
    CustomerRecentActivity,
    CustomerStoresVisited
  }
})
export default class CustomerDetail extends Vue {
  @Prop({ required: true }) data: any;
  preview: boolean = false;
  activeTabKey = 'recent-activity';

  get getPicture() {
    try {
      if (!this.data.picture.includes('https')) return '';
      return {
        background: `url('${this.data.picture}')`,
        backgroundSize: 'cover'
      };
    } catch {
      return 'hasNoImage';
    }
  }

  get tabMapper() {
    return {
      'recent-activity': {
        label: 'Recent activity',
        component: 'CustomerRecentActivity',
        componentProps: {
          customerId: this.data.id
        }
      },
      'stores-visited': {
        label: 'Stores visited',
        component: 'CustomerStoresVisited',
        componentProps: {
          customerId: this.data.id
        }
      }
    };
  }

  get tabs() {
    return Object.entries(this.tabMapper).map(([key, value]) => ({
      key,
      label: value.label
    }));
  }

  handleTabChanges(tabKey: string) {
    this.activeTabKey = tabKey;
  }

  closeSubModal() {
    this.preview = !this.preview;
    const modalConfig = {
      isOpen: true,
      component: 'AdminCustomerDetails',
      data: this.data,
      subModal: {
        isOpen: false
      }
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }
}
